import { render, staticRenderFns } from "./AssociatedSitesCardComponents.vue?vue&type=template&id=5f3e529c&scoped=true&"
var script = {}
import style0 from "./AssociatedSitesCardComponents.vue?vue&type=style&index=0&id=5f3e529c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3e529c",
  null
  
)

export default component.exports